import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { Button, Card, Typography, Statistic, Row, Col } from 'antd';
import { CloseCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import {
  selectLoading,
  selectInfo,
  selectPaymentSaving,
  selectPaymentError,
  selectPaymentDeleteStart,
  selectPaymentDeleteError,
  fetchProfile,
  savePaymentInfo,
  deletePaymentInfo,
} from '../../features/profile/profileSlice';
import { Layout } from '@builty/components/Layout';
import { Spinner } from '@builty/components/Spinner';
import './Billing.scss';

const CARD_OPTIONS = {
  iconStyle: "solid",
  style: {
    base: {
      iconColor: "#444",
      color: "#444",
      ":-webkit-autofill": {
        color: "#444"
      },
      "::placeholder": {
        color: "#bfbfbf"
      }
    },
    invalid: {
      iconColor: "#ff4d4f",
      color: "#ff4d4f"
    }
  }
};

export const Billing = () => {
  const dispatch = useDispatch();

  const loading = useSelector(selectLoading);
  const { paymentMethods, freeAddressLookups, credit } = useSelector(selectInfo);
  const paymentSaving = useSelector(selectPaymentSaving);
  const paymentError = useSelector(selectPaymentError);
  const paymentDeleteStart = useSelector(selectPaymentDeleteStart);
  const paymentDeleteError = useSelector(selectPaymentDeleteError);

  const stripe = useStripe();
  const elements = useElements();

  useEffect(() => {
    dispatch(fetchProfile());
  }, [dispatch]);


  const onAddCard = () => {
    const cardElement = elements.getElement(CardElement);
    dispatch(savePaymentInfo(stripe, cardElement));
  }

  if (loading) return (
    <Spinner />
  );

  return (
    <Layout.Content>
      <div className="u-mb-xxlarge u-text-align-center">
      <Row>
        <Col xs={24} md={8}>
          <Statistic title="Pay as you go API:" value="$0.20/record" />
        </Col>
        <Col xs={24} md={8}>
          <Statistic title="Free Permit Lookups" value={freeAddressLookups} />
        </Col>
        <Col xs={24} md={8}>
          <Statistic title="Credit" value={credit} formatter={value => `$${(value/100).toFixed(2)}`} />
        </Col>
      </Row>
      </div>
      <Typography.Title level={4} className="u-text-align-center">Billing Card:</Typography.Title>
      <div className="u-mb-xxlarge">
        { paymentMethods?.length
          ? (
              <>
                <Card size="small" className="c-billing__card-element">
                  <div className="c-billing__card-element-inner">
                    <Typography.Text>Card ending in { paymentMethods[0]['last4'] }</Typography.Text>
                    <Button
                      type="danger"
                      icon={<DeleteOutlined />}
                      loading={paymentDeleteStart}
                      onClick={() => dispatch(deletePaymentInfo(paymentMethods[0].id))}
                    />
                  </div>
                </Card>
                {paymentDeleteError && (
                  <Typography.Paragraph type="danger">{paymentDeleteError}</Typography.Paragraph>
                )}
              </>
          ) : (
            <div>
              <Card size="small" className="c-billing__card-element">
                <CardElement options={CARD_OPTIONS} />
              </Card>
              <Typography.Paragraph className="u-text-align-center">You will be charged in $10 increments</Typography.Paragraph>
              {paymentError && (
                <div style={{ margin: '0 0 15px', textAlign: 'center' }}>
                  <Typography.Text type="danger" >
                    <CloseCircleOutlined style={{ marginRight: 8 }} />
                    {paymentError}
                  </Typography.Text>
                </div>
              )}
              <div className="c-billing__card-element-submit">
                <Button
                  type="primary"
                  onClick={onAddCard}
                  disabled={!stripe || !elements}
                  loading={paymentSaving}>
                  Save payment information
                </Button>
              </div>
            </div>
          )
        }
      </div>
    </Layout.Content>
  );
}